import { useRef, useEffect } from 'react';
import { Map, Marker, NavigationControl, Popup } from 'maplibre-gl';
import * as AWS from 'aws-sdk/global';
import { Signer } from '@aws-amplify/core';
import 'maplibre-gl/dist/maplibre-gl.css';
import './InteractiveMap.css';

export const InteracitveMap = ({ devices }: { devices?: any[] }) => {
  const mapContainer = useRef<HTMLDivElement>(null);
  const lng = -176.3;
  const lat = 33.2;
  const zoom = 1.55;
  const env = import.meta.env;
  const IdentityPoolId = env.VITE_AWS_IDENTITY_POOL_ID;
  const mapName = env.VITE_MAP_NAME;

  let map: any;

  AWS.config.region = IdentityPoolId.split(':')[0];
  const credentials = new AWS.CognitoIdentityCredentials({ IdentityPoolId });

  const refreshCredentials = async () => {
    await credentials.refreshPromise();
    setTimeout(refreshCredentials, credentials.expireTime.valueOf() - new Date().valueOf());
  };

  const transformRequest = (url: string, resourceType: any) => {
    if (resourceType === 'Style' && !url.includes('://')) {
      url = `https://maps.geo.${AWS.config.region}.amazonaws.com/maps/v0/maps/${url}/style-descriptor`;
    }
    if (url.includes('amazonaws.com')) {
      return {
        url: Signer.signUrl(url, {
          access_key: credentials.accessKeyId,
          secret_key: credentials.secretAccessKey,
          session_token: credentials.sessionToken,
        })
      }
    }
    return { url };
  }

  useEffect(() => {
    refreshCredentials().then(() => {
      if (map) return;
      map = new Map({
        container: mapContainer.current!,
        style: mapName,
        center: [lng, lat],
        zoom: zoom,
        transformRequest,
      });
      map.addControl(new NavigationControl(), 'bottom-right');
      map.on('load', () => {
        if (devices) {
          for (const device of devices) {
            const popup = new Popup({ offset: 35 }).setHTML(`
              <h3>${device['device.name']}</h3>
              <p>${device['device.prod_code']}</p>
              <p>${device['device.id']}</p>
              <p>${device['device.address']}</p>
            `);
            const marker = new Marker({ color: 'green' })
              .setLngLat([device['device.longitude'], device['device.latitude']])
              .setPopup(popup)
              .addTo(map);
          }
        }
      });
      // document.querySelector('.map-style.esri-navigation')?.addEventListener('click', function () {
      //   map.setStyle('esri-navigation');
      // });
      // document.querySelector('.map-style.here-explore-truck')?.addEventListener('click', function () {
      //   map.setStyle('here-explore-truck');
      // });
      // document.querySelector('.map-style.here-berlin')?.addEventListener('click', function () {
      //   map.setStyle('here-berlin');
      // });
      // document.querySelector('.map-style.esri-light-gray-canvas')?.addEventListener('click', function () {
      //   map.setStyle('esri-light-gray-canvas');
      // });
      // document.querySelector('.map-style.esri-imagery')?.addEventListener('click', function () {
      //   map.setStyle('esri-imagery');
      // });
    })
  }, [devices]);

  return (
    <div className="map-wrap">
      <div ref={mapContainer} className="map" />
      {/* <div className="layer-control">
        <div className="map-style esri-navigation">
          <img src="img/esri-navigation.png" alt="Esri Navigation" style={{width: '100%'}} />
          <div className="text">
            Street
          </div>
        </div>
        <div className="map-style here-explore-truck">
          <img src="img/here-explore-truck.png" alt="HERE Explore Truck" style={{width: '100%'}} />
          <div className="text">
            Truck
          </div>
        </div>
        <div className="map-style here-berlin">
          <img src="img/here-berlin.png" alt="HERE Berlin" style={{width: '100%'}} />
          <div className="text">
            3D
          </div>
        </div>
        <div className="map-style esri-light-gray-canvas">
          <img src="img/esri-light-gray-canvas.png" alt="Esri Light Gray Canvas" style={{width: '100%'}} />
          <div className="text">
            Light
          </div>
        </div>
        <div className="map-style esri-imagery">
          <img src="img/esri-imagery.png" alt="Esri Imagery" style={{width: '100%'}} />
          <div className="text">
            Satellite
          </div>
        </div>
      </div> */}
    </div>
  );
};